import request from "../utils/request-axios";
import api from "../utils/api";

export function getRecordPage(params) {
  return request(`${api.getRecordPage}`, {
    loading: true,
    method: 'get',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/services/record.js